import $ from 'jquery';
import { gsap } from 'gsap';
import { SplitText } from 'gsap/SplitText';

import { $Elements, Animations, Breakpoints, Classes, Events } from '../global/constants';
import { elementPosition } from '../global/helpers';

// ---------- Init Scroll Animation ----------

export const initScrollAnimations = () => {

	// ---------- Menu ----------

	$Elements.HeaderWrapper.each(function() {

		Animations.global.push(() => {

			gsap.timeline({
				scrollTrigger: {
					start: 1,
					end: 'max',
					onUpdate: (self) => {
						(self.direction === -1) ? this.classList.remove(Classes.shrink) : this.classList.add(Classes.shrink);
						(self.progress > 0) ? this.classList.add(Classes.shrinkable) : this.classList.remove(Classes.shrinkable);
					}
				}
			});
		});
	});

	// ---------- Animated Section ----------

	$('.animated-section:not(.transition-clone), .animated-column').each(function() {

		Animations.global.push(() => {

			const timeline = gsap.timeline({
				scrollTrigger: {
					trigger: this,
					once: true,
					start: 'top 80%',
					toggleClass: Classes.active,
				}
			});
		});
	});

	// ---------- Content Sections ----------

	$('.parallax-section:not(.fixed):not(.transition-clone), .hero-section').each(function() {

		Animations.mobile.max.push(() => this.classList.remove(Classes.moving));

		Animations.mobile.min.push(() => {

			this.classList.add(Classes.moving);

			const image = this.querySelector(':scope .section-image');
			const speed = parseInt(this.dataset.speed, 10);

			if(image) {

				const timeline = gsap.timeline({
					scrollTrigger: {
						trigger: this,
						start: 'top bottom',
						end: 'bottom top',
						scrub: true,
						invalidateOnRefresh: true,
					},
				});

				const offset = () => image.offsetHeight - ((image.offsetHeight - this.offsetHeight) / 2);

				timeline.fromTo(
					image,
					{ y: () => offset() * (speed / 100), ease: 'none' },
					{ y: () => offset() * (-speed / 100), ease: 'none' }
				);
			}
		});
	});

	$('.hero-section:not(.fixed):not(.transition-clone)').each(function() {

		Animations.mobile.max.push(() => this.classList.remove(Classes.moving));

		Animations.mobile.min.push(() => {

			this.classList.add(Classes.moving);

			const image = this.querySelector(':scope .column-image');
			const speed = 1;

			if(image) {

				const timeline = gsap.timeline({
					scrollTrigger: {
						trigger: this,
						start: 'top bottom',
						end: 'bottom top',
						scrub: true,
						invalidateOnRefresh: true,
					},
				});

				const offset = () => image.offsetHeight - ((image.offsetHeight - this.offsetHeight) / 2);

				timeline.fromTo(
					image,
					{ y: () => offset() * (speed / 100), ease: 'none' },
					{ y: () => offset() * (-speed / 100), ease: 'none' }
				);
			}
		});
	});

	$('.fullscreen-image-section').each(function() {

		Animations.mobile.min.push(() => {
			const content = this.querySelector('.image-column');
			const contentMainImage = this.querySelector('.column-image');
			const mainImage = this.querySelector('.column-image .image');

			if(content && mainImage && contentMainImage) {

				const timeline = gsap.timeline({
					defaults: {
						ease: "power1.inOut",
						force3D: !0
					},
					scrollTrigger: {
						trigger: this,
						start: 'top 70%',
						end: 'bottom bottom',
						scrub: !0,
						invalidateOnRefresh: true,
					},
				});

				const getDimensions = (element) => element.getBoundingClientRect();
				const calculateScale = (image) => {
					const windowWidth = window.innerWidth;
					const imageDimension = getDimensions(image)
					const widthScale = windowWidth / imageDimension.width;
					return widthScale;
				};

				timeline.to(content,
					{ scale: () => calculateScale(contentMainImage) },
					0
				);

				timeline.to(mainImage, { scale: 1 }, 0);

			}
		})
	});

	$('.gallery-section').each(function() {

		Animations.global.push(() => {

			const content = this.querySelector(':scope .section-columns');

			if(content) {

				const columns = gsap.utils.toArray('.content-column', content);
				const contentWidth = () => (columns.reduce((val, column) => val + column.offsetWidth, 0)) + Math.max(0, window.innerWidth - Breakpoints.xxl);
				const triggerOffset = () => {
					const position = elementPosition(content);
					return position.top;
				}

				const timeline = gsap.timeline({
					scrollTrigger: {
						trigger: this,
						pin: true,
						scrub: true,
						invalidateOnRefresh: true,
						start: () => triggerOffset(),
						end: () => '+=' + contentWidth(),
					},
				});

				timeline.to(content, { x: () => window.innerWidth - contentWidth(), ease: "none" });
			}
		});
	});

	$('.simple-text-image-section, .visit-section').each(function() {
		const section = this;

		Animations.mobile.min.push(() => {

			const image = this.querySelector('.image-column');
			const quote = this.querySelector('.quote-column:not(.image-empty)');

			if(image && section) {

				const timeline = gsap.timeline({
					scrollTrigger: {
						trigger: section,
						start: 'top bottom',
						end: 'bottom top',
						scrub: true,
						invalidateOnRefresh: true,
					},
				});

				timeline.fromTo(
					image,
					{ y: '10vh', ease: 'none' },
					{ y: '-10vh', ease: 'none' }
				);

				const opacity = gsap.timeline({
					scrollTrigger: {
						trigger: section,
						start: 'top bottom',
						end: 'top top',
						scrub: true,
						invalidateOnRefresh: true,
					},
				});

				opacity.fromTo(
					image,
					{ opacity: 0, ease: 'none' },
					{ opacity: 1, ease: 'none' }
				);
			}

			if(quote && section) {
				gsap.to(quote, {
					scrollTrigger: {
						trigger: section,
						scrub: true,
						start: "top top",
						end: "bottom center",
					},
					y: '5vh',
					ease: 'none',
				});
			}
		});
	});

	$('.center-text-image-section').each(function() {
		const section = this;

		Animations.mobile.min.push(() => {

			const image = this.querySelector('.image-column');
			const quote = this.querySelector('.quote-column:not(.image-empty)');

			if(image && section) {

				const timeline = gsap.timeline({
					scrollTrigger: {
						trigger: section,
						start: 'top bottom',
						end: 'bottom top',
						scrub: true,
						invalidateOnRefresh: true,
					},
				});

				timeline.fromTo(
					image,
					{ y: '5vh', ease: 'none' },
					{ y: '-5vh', ease: 'none' }
				);

				const opacity = gsap.timeline({
					scrollTrigger: {
						trigger: section,
						start: 'top bottom',
						end: 'top top',
						scrub: true,
						invalidateOnRefresh: true,
					},
				});

				opacity.fromTo(
					image,
					{ opacity: 0, ease: 'none' },
					{ opacity: 1, ease: 'none' }
				);
			}

			if(quote && section) {
				gsap.to(quote, {
					scrollTrigger: {
						trigger: section,
						scrub: true,
						start: "top top",
						end: "bottom center",
					},
					y: '5vh',
					ease: 'none',
				});
			}
		});
	});

	$('.quote-section').each(function() {

		const quote = this.querySelector('.quote');
		const author = this.querySelector('.author');


		Animations.mobile.min.push(() => {
			if(quote) {
				const timeline = gsap.timeline({
					scrollTrigger: {
						trigger: quote,
						start: 'top bottom',
					}
				});

				let splitTextQuote = new SplitText(quote, { type: "words" });
				timeline.from(splitTextQuote.words, {
					y: '100%',
					x: '-5%',
					rotationZ: 5,
					opacity: 0,
					duration: 0.4,
					ease: 'ease-in-out',
					stagger: 0.05,
				});

				if(author) {
					let splitTextAuthor = new SplitText(author, { type: "lines" });
					timeline.from(splitTextAuthor.lines, {
						y: '100%',
						opacity: 0,
						duration: 0.8,
						ease: 'power1.out',
						stagger: 0.1,
					});
				}

				timeline.fromTo(
					quote,
					{ '--scaleX': 0 },
					{
						'--scaleX': 1,
						duration: 0.5,
						ease: 'ease-out',
						onUpdate: function() {
							quote.style.setProperty('--scaleX', this.targets()[0].style.getPropertyValue('--scaleX'));
						},
					},
					'<'
				);

			}
		});
	});

	$('.link-footer-section').each(function() {

		const link = this.querySelector('.button a');


		Animations.mobile.min.push(() => {
			if(link) {

				const timeline = gsap.timeline({
					scrollTrigger: {
						trigger: link,
						start: 'top bottom',
					}
				});

				let splitTextLink = new SplitText(link, { type: "words" });
				timeline.from(splitTextLink.words, {
					y: '100%',
					x: '-3%',
					rotationZ: 3,
					opacity: 0,
					duration: 0.8,
					delay: 0.7,
					ease: 'ease-in-out',
					stagger: 0.06,
				});

				timeline.fromTo(
					link,
					{ '--scaleX': 0 },
					{
						'--scaleX': 1,
						duration: 0.5,
						ease: 'ease-out',
						onUpdate: function() {
							link.style.setProperty('--scaleX', this.targets()[0].style.getPropertyValue('--scaleX'));
						},
					}
				);
			}
		});
	});

	$('.wines-list-section').each(function() {
		const section = this;

		Animations.mobile.min.push(() => {
			gsap.to(this, {
				backgroundPositionY: '-50%',
				ease: 'none',
				scrollTrigger: {
					trigger: section,
					start: 'top bottom',
					end: 'bottom top',
					scrub: true
				}
			});
		})

		$(section).find('.image-column').each(function() {
			const column = this;

			Animations.mobile.min.push(() => {
				const image = column.querySelector('.column-image');
				const content = column.querySelector('.column-content');

				if(image) {
					const timeline = gsap.timeline({
						scrollTrigger: {
							trigger: column,
							start: 'top bottom',
							end: 'bottom top',
							scrub: 0.5,
							invalidateOnRefresh: true,
						},
					});

					timeline.fromTo(
						image,
						{ y: '-3vh', opacity: 0.8, ease: 'sine.inOut' },
						{ y: '3vh', opacity: 1, ease: 'sine.inOut' }
					);

					if(content) {
						timeline.fromTo(
							content,
							{ y: '3vh', opacity: 0.8, ease: 'sine.inOut' },
							{ y: '-3vh', opacity: 1, ease: 'sine.inOut' },
							'-=0.1'
						);
					}
				}
			});
		});
	});
};

$Elements.document.on(Events.page.enter, () => initScrollAnimations());
